import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon,
  SocialButtons,
  // SignupForm,
  AboutBanner,
  GetStartedInput
} from '../../components'
import Styles from './Toolkit.css'
import container from '../../helpers/container'
import ReactPlayer from 'react-player'
import {CopyToClipboard} from 'react-copy-to-clipboard';

@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about fossil free and socially responsible investment options in the plan.\nI am concerned about the financial risks associated with investing my retirement savings in fossil fuel companies. Laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what fossil fuel companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, socially responsible options?\nSocially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.\nThere is an online tool, FossilFreeFunds.org, which screens many commonly available mutual funds for investments in fossil fuel companies, and identifies funds that are socially responsible and fossil free. If none of our current plan options are socially responsible and fossil free, this tool could be used to find suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]',
      copied: false,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true});
  };

  renderVideoWrap = () => {
    return (
      <div styleName='content-photo-wrap'>
        <div styleName='contents'>
          <div styleName='answer-title'>
            Sustainable, Fossil Free 401(k)s
          </div>
          <div styleName='content-info'>
            <p>How sustainable and fossil-free are your 401k fund choices? Your 401(k) portfolio could be an engine for more positive impact. Join Fossil Free Funds and HIP Investor for a webinar to learn how to advance your employer-sponsored retirement plan to reflect more sustainable fund choices that are better positioned for a future world of cleaner, greener energy – while seeking lower future risk in your portfolio.</p>
          </div>
          <Link
            to={'../files/webinar-slides/Sustainable-Fossil-Free-401ks-FossilFreeFunds-AsYouSow-HIPinvestor.pdf'}
            title='Sustainable, Fossil Free 401(k)s - Webinar slide deck'
            targetBlank
          >
            <div styleName={'slide-btn tlink'}>
              <i className='fa fa-file-o'/>&nbsp;&nbsp;&nbsp;View the slides<LinkIcon />
            </div>
          </Link>
        </div>
        <div styleName='photo-wrap'>
          <ReactPlayer
            url='https://vimeo.com/151846057'
            volume={0.5} />
        </div>
      </div>
    )
  }

  renderToolkit401kGraphicWrap = () => {
    return (
      <div styleName='content-photo-wrap'>
        <div styleName='contents'>
          <div styleName='answer-title'>
            If your investments are in your employer-sponsored plan
          </div>
          <div styleName='content-info'>
            <p>It is possible to change what the plan offers, but it will take more effort than if you have an IRA or a personal investment that you solely control (see below). You will need to engage the plan administrator to help find the right blend of funds to satisfy the many employees that all invest in the same basket of mutual funds. This may take time and possibly some coordination with your co-plan participants.</p>
          </div>
        </div>
        <div
          styleName='photo-graphic'
          title='Americans have $5.1 trillion invested in 401(k)s'
        />
      </div>
    )
  }
  renderToolkitFundsPhotoWrap = () => {
    return (
      <div styleName='content-photo-wrap'>
        <div styleName='contents'>
          <div styleName='answer-title'>
            If you&rsquo;re an individual investor
          </div>
          <div styleName='content-info'>
            <p>It&rsquo;s your money, and your financial advisor works for you. You just need to have a meeting to discuss what you have learned about your holdings and how you would like them changed to align with your values. An investment professional will advise you of potential risk and you can make your own decisions.</p>
            <p>You can trade your own portfolio, or tell your manager to do it. They may push back and tell you that you&rsquo;ll make less money. Again, you can reply, &ldquo;Maybe, but it&rsquo;s my money, I want less risk, and fossil fuels are a risky business.&rdquo; It&rsquo;s a financial advisors job to manage <i>your</i> money, so you should drive home the point in no uncertain terms.</p>
          </div>
        </div>
        <div
          styleName='photo-funds'
          title='How to make a change and invest your money fossil free'
        />
      </div>
      )
  }
  renderToolkitContent = (toolkitTitle) => {
    const url = config.domain + config.routes.toolkit
    const message = 'Action toolkit to move your money'
    return (
      <div>
        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>
            <div styleName='title'>
              Fossil free action toolkit
            </div>

            <div styleName='subtitle'>
              How to make a change and invest your money fossil free
            </div>

            { this.renderToolkitFundsPhotoWrap() }

            <p>Ask for help finding the best choices. The advisor may say no if you tell them to invest in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to remove the risk, not a specific fund; focus on risk, especially future risk, as well as returns. If they&rsquo;re being lazy or unwilling to help you with this transition, find a new advisor. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want innovation, you might need a new advisor.</p>

            <SocialButtons message={message} link={url}/>

            <div styleName='section-title'>
              Resources for investing fossil free
            </div>

            <p>We've collected a set of resources that can help you get started on your fossil free investing journey. From financial consulting firms, to educational resources, to research providers, these resources explain the details of socially responsible financial investing, and help to ensure you're working with firms that are aligning your investments with your values.</p>

            <Link
              to={config.routes.resources}
              title='Resources'
            >
              <div styleName={'tlink slide-btn'}>
                  Resources<LinkIcon />
              </div>
            </Link>

          </div>
        </div>

        <GetStartedInput />

        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>

            <div styleName='section-title'>
              Adding fossil free options to your retirement plan
            </div>

            { this.renderToolkit401kGraphicWrap() }

            <div styleName='answer-title'>
              Step 1 – Talk to your colleagues and build a coalition
            </div>
            <div styleName='content-info'>
              <p>To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you&rsquo;re writing to someone in power, advocating on behalf of 10 or even 20 people carries a lot more weight than just one. One way to spur interest would be sharing the results from your Fossil Free Funds search among fellow employees. All plan participants are offered the same basket of mutual funds as you are, so they are probably asking the same questions right now.</p>
              <p>Some companies have “green teams,” and there may be affinity groups for women or LGBT employees, and if there isn’t one already, it may be time to create one for climate change. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media. </p>
            </div>
            <div styleName='answer-title-spaceabove'>
              Step 2 – Identify the best people to speak with
            </div>
            <div styleName='content-info'>
              <p>The 401(k)/403(b) plan administrator, manager, or coordinator should be known if you are a plan participant, and that&rsquo;s where to start. There could also be a chief sustainability officer or employee engagement manager, and those could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might have some sympathy for the cause. Do any of them volunteer or have connections with organizations concerned with climate change? Look for indicators that they&rsquo;re friendly to sustainability and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it&rsquo;s an important issue for many employees. If it&rsquo;s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.</p>
            </div>
            <div styleName='answer-title-spaceabove'>
              Step 3 – Bring a solution to the table
            </div>
            <div styleName='content-info'>
              <p>The usual starting point in these conversations is: &ldquo;We want to reduce the future risk of our 401(k) fund choices. We also want to invest in a clean energy future. How can we enhance our 401(k) choices to do so?&rdquo; Here are the criteria. Getting new fund choices added to the list of the existing plan options is a formal process, and could take up to a year to be added. Larger companies often have some form of investment committee, which engages an investment advisor. There may be some funds in your plan that you see contain only one fossil fuel company. You could ask the plan administrator to call the fund manager and say, &ldquo;Is there a substitute for this one company? If you made one change you would be fossil free free!&rdquo;</p>
              <p>If the investment advisor and plan administrator refuse to help in swapping out some fossil fuel-heavy funds for some fossil free funds, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, &ldquo;But you&rsquo;ll make less money if you&rsquo;re not invested in fossil fuels,&rdquo; you can say, &ldquo;Actually, fossil fuels are a risky investment. We want to diversify, and be part of the clean energy future.&rdquo;</p>
            </div>

            <div styleName='answer-title-spaceabove'>
              Sample letter to plan administrator
            </div>
            <div styleName='content-info'>
              <div styleName='letter-boxquote'>
                <p>Dear Plan Administrator,</p>
                <p>I am an employee of <strong>[Company Name]</strong>, and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about fossil free and socially responsible investment options in the plan.</p>
                <p>I am concerned about the financial risks associated with investing my retirement savings in fossil fuel companies. Laws curbing the use of fossil fuels are being put in place, energy efficiency measures are being implemented across nearly every sector of the economy, and renewable energy is driving down demand for fossil fuel-based energy. These changes pose substantial financial risk to fossil fuel companies. One example of this growing risk: over the past five years, the largest U.S coal companies have gone bankrupt, while other U.S. based coal firms have lost nearly 90% of their stock value.</p>
                <p><strong>I believe it is my right to know what companies my retirement savings are invested in.</strong> Can you please tell me how I can find out what fossil fuel companies are held in each of the investment options offered in our company plan? Does our retirement plan offer any fossil free, socially responsible options?</p>
                <p>Socially responsible investing is no longer just an ethical issue. It is a key factor impacting financial well-being. New guidelines from the Department of Labor state that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.  </p>
                <p>There is an online tool, fossilfreefunds.org, which screens many commonly available mutual funds for investments in fossil fuel companies, and identifies funds that are socially responsible and fossil free. <strong>If none of our current plan options are socially responsible and fossil free, this tool could be used to find suitable mutual funds that could be included in our plan.</strong></p>
                <p>Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.</p>
                <p>Best,</p>
                <p><strong>[Your Name]</strong></p>
                <p><strong>[Your contact information (company department, email, phone)]</strong></p>
              </div>

              <CopyToClipboard
                onCopy={this.onCopy}
                text={this.state.value}>
                <button
                  styleName='letter-boxquote-copy-button'>

                  {
                    this.state.copied ?
                    null :
                    (
                      <span><i className='fa fa-files-o'/>&nbsp;&nbsp;&nbsp;</span>
                    )
                  }

                  {
                    this.state.copied ?
                      'Copied!' :
                      'Copy to clipboard'
                  }

                </button>
              </CopyToClipboard>

            </div>

            <div styleName='section-title'>
              Watch our video how-to guide
            </div>

            { this.renderVideoWrap() }

          </div>
        </div>

        <GetStartedInput />

        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>

            <div styleName='section-title'>
              White paper
            </div>
            <div styleName='answer-title'>
              Aligning defined contribution plans with corporate sustainability goals to spur employee innovation and engagement
            </div>
            <p>As millennial-aged employees now represent the majority of the U.S. workforce, it is increasingly important that corporate management finds ways to engage them in the company. Creating defined contribution plans which connect to their core values – like solving human, social and environmental problems through their work and investments – can spur employee engagement and spark innovation.</p>

            <Link
              to={config.links.whitePaper}
              title='Read the white paper'>
                <div styleName={'slide-btn tlink'}>
                  Read the white paper<LinkIcon />
                </div>
            </Link>

            <p>Furthermore, adding ESG funds to an organization’s employee contribution plan enables a corporation to align its stated climate, environmental, social, and other sustainability policies, including adoption of U.N. Sustainable Development Goals (SDGs), and the U.N. Principles of Responsible Investing (UNPRI) with its investment options. The oft-heard phrase, “put your money where your mouth is” has never been truer or easier to implement.</p>

            <p>Between 2012 and 2016 the market for mutual funds and exchange traded funds (ETFs) with an Environmental, Social, or Governance (ESG) focus has increased $4.98 trillion, up to $8.72 trillion, a growth of over 133%.[i]  The benefits of including ESG considerations in investment decisions have become more widely understood and the market has responded by increasing investments in funds that include these concerns in their prospectus and holdings. In addition to the potential financial upside of ESG investments, a growing number of investors are moving to ESG-oriented funds as a way to reduce risk and incorporate their values in their investment decisions. This is largely driven by the increasing proportion of millennials in the workforce. A whopping 85% of millennials surveyed in the 2016 U.S. Trust study, “Insights on Wealth and Worth,” said they consider their investment decisions as “a way to express their social, political, and environmental values.”[ii]</p>

            <p>Despite the growth of ESG-oriented funds in the wider investment market, the $8.4 trillion in U.S. corporate defined contribution plans (including 401(k), 403(b), and IRAs) do not reflect this growth and in fact have barely begun to include ESG funds in their portfolios.[iii] As an example, Vanguard reported that only 9% of its employee plans included ESG funds, most of which offered only a single fund rather than a suite of offerings.[iv] This discrepancy provides a tremendous opportunity for corporate plan administrators to align corporate values and sustainability goals with investments, while simultaneously enticing new employees, retaining existing ones, and increasing participation and contributions through a simple change in policy.</p>

            <p>A recent 2015 Department of Labor ERISA guidance document indicates that considering ESG issues when making investments is not only allowed as part of a fiduciaries’ consideration, but where such issues may directly affect the economic value of an investment, fiduciaries should appropriately consider such factors.</p>

            <p>This white paper highlights case studies and recent investing trends demonstrating the benefits of incorporating ESG options into corporate defined contribution plans. It shows that those corporations providing a greater array of ESG mutual funds and exchange traded funds (ETFs) in their plans will benefit from overall corporate coherence of policy and practice and facilitate a shift in corporate culture to respect and amplify employee values. This leads to material benefits for both the company and the employees, is relatively simple to implement once an executive decision is made to make such an adjustment, and is most successful when employees are part of the process from the beginning and through implementation.</p>

            <Link
              to={config.links.whitePaper}
              title='Read the white paper'>
                <div styleName={'slide-btn tlink'}>
                  Read the white paper<LinkIcon />
                </div>
            </Link>

            <div styleName='answer-title-spaceabove'>
              Acknowledgements
            </div>
            <p>Thanks to R. Paul Herman, founder and CEO of HIP Investor which rates 401(k) plans for fossil free and sustainability, for his assistance in writing this toolkit and to Rob Thomas of Social(k) and Timothy Yee of Green Retirement for reviewing it.</p>
            <br/>

          </div>
        </div>

      </div>

    )
  }

  render() {
    const title = 'Fossil free action toolkit'
    const description = 'Get your money out of fossil fuels. Use the Fossil Free Funds Action Toolkit to make a change and move your money.'
    const url = config.domain + config.routes.toolkit

    // const bannerImage = 'green'
    // const bannerHeadline = 'Fossil free action toolkit'
    // const bannerSubtitle = 'Action toolkit to move your money'

    return (
      <div>
        {container.helmet(title, description, url)}

        { /* <div styleName='image-banner-container'>
          <div styleName='image-banner-container-inner'>
            <div styleName={'image-banner-'+bannerImage}>
              <div styleName='image-banner-headline'>{bannerHeadline}</div>
              <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
            </div>
          </div>
        </div> */ }

        { this.renderToolkitContent(title) }

        <GetStartedInput />

        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>
            <AboutBanner />
          </div>
        </div>

      </div>
    )
  }
}
